export const PRODUCT_VISIBILITY_REPORT = {
    BUYER_DROPDOWN: {
        SEARCH_INPUT: "buyer-search-input",
        INFINITE_LOADER: "buyer-infinite-loader",
        BUYER_LIST_ITEM: "buyer-list-item",
    },
    PRODUCT_DROPDOWN: {
        SEARCH_INPUT: "product-search-input",
        INFINITE_LOADER: "product-infinite-loader",
        PRODUCT_LIST_ITEM: "product-list-item",
    },
    SEARCH_BTN: "search-btn",
    REPORT: "report",
    PRODUCT_TEXTFIELD: "product-id-search-textfield",
};
